module.exports = __webpack_public_path__ + "assets/dental-care.bf0ebc99.svg";